export const TRANSITION_ROUTING = [
    {
        path: '/transition',
        name: 'transition',
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Mã vận đơn', pathName: 'transition', icon: 'fa fa-truck' },
            ]
        },
        component: () => import('./Transition.vue'),
        redirect: { name: 'transition-index' },
        children: [
            {
                path: '/ma-van-don.html',
                name: 'transition-index',
                component: () => import('./list/List.vue'),
            },
        ]
    }
];